export default {
    "company_header": "会社の詳細",
    "header_product_warning": "適切なGrabCAD製品にサインアップしますか？{0}にサインアップする",
    "label": {
        "first_name": "名",
        "last_name": "姓",
        "name": "名前",
        "company_name": "会社名",
        "university_name": "学校名",
        "role": "役職",
        "company_size": "会社の規模",
        "phone_number": "電話番号",
        "printer": "3D プリンタをお持ちですか。",
        "student_printer": "学校に 3D プリンタが配置されていますか",
        "uses_printer_for": "3D プリンタの使用目的は何ですか。",
        "shop_owner": "モデルショップの管理責任者ですか？",
        "shop_users_expected": "ショップへは何人から注文が送信されましたか？",
        "email": "電子メール",
        "email_confirm": "電子メールの確認",
        "email_again": "電子メールの再入力",
        "password": "パスワード",
        "country": "場所",
        "state": "都道府県/地方",
        "password_confirm": "パスワードの確認入力",
        "password_again": "電子メールの再入力",
        "password_hint": "6 文字以上",
        "interested_in": "次のことに興味があります...",
        "industry_vertical": "業種",
        "industry_level": "職務レベル",
        "business_email": "業務用電子メール",
        "business_email_confirm": "業務用電子メールの確認",
        "recaptcha": "ロボットではなく人間がアクセスしていることを確認するため、ご協力ください",
        "industry_level_select": "職務レベルを選択",
        "company_size_select": "規模を選択",
        "industry_vertical_select": "業種を選択"
    },
    "placeholders": {
        "name": "例：John Smith",
        "first": "名",
        "last": "姓",
        "email": "電子メールの入力",
        "email_confirm": "電子メールの再入力",
        "password": "パスワードの入力",
        "company_name": "会社名の入力",
        "university_name": "学校名の入力",
        "phone_number": "電話番号の入力",
        "printer": "応答の選択",
        "country": "国の選択",
				"state": "都道府県または地方を選択してください",
        "business_email": "業務用電子メールの入力",
        "business_email_confirm": "業務用電子メールの確認"
    },
    "terms": {
        "buy_now_text": "[次へ] をクリックすると、次を読んだことを確認することになります",
        "workbench_text": "[Workbench に登録] をクリックすると、次を読んだことを確認することになります",
        "print_text": "[登録] をクリックすると、次を読んだことを確認することになります",
        "text": "[コミュニティに登録] をクリックすると、次を読んだことを確認することになります",
        "link": "サービス利用規約"
    },
	"software_terms": {
		"link": "ソフトウェアのご利用条件"
	},
    "privacy_policy": {
        "and": "および",
        "link": "プライバシー ポリシー",
        "text": "およびこれらに準拠することを承認し、同意するものとします。"
    },
    "actions": {
        "next": "次へ",
        "workbench_sign_up": "Workbench に登録",
        "sign_up_button": "登録",
        "shop_sign_up": "GrabCAD Shopの無料トライアルをリクエストする",
        "sign_up": "コミュニティに登録",
        "cancel": "キャンセル"
    },
    "error": {
        "name_empty": "名前を追加してください",
        "email_taken": "この電子メールはすでに登録されています。ログインするか、別の電子メールを選択してください。",
        "email_empty": "電子メールを追加してください",
        "email_nomatch": "電子メールは一致する必要があります",
        "email_look": "有効な電子メールを記入してください",
        "password_nomatch": "パスワードは一致する必要があります",
        "password_short": "パスワードが短すぎます。6 文字以上で指定してください。",
        "password_empty": "パスワードを記入してください",
        "recaptcha": "チェックボックスをクリックし、ロボットではなく人間がアクセスしていることを確認します",
        "country_blocked": "GrabCAD に登録することは許可されていません",
        "blank": "は空白にできません"
    },
    "active": {
        "email": "ご使用の電子メールを入力していただければ、アカウントの確認リンクをお送りいたします。"
    },
    "own_printer": {
        "default": {
            "no_dont_plan": "いいえ、その予定はありません",
            "no_but_interesed": "いいえ、興味はあります",
            "yes_for_work": "はい、仕事用に使用します",
            "yes_as_hobby": "はい、趣味として使用します",
            "yes_for_other": "はい、その他の理由で使用します"
        },
        "student": {
            "no_dont_plan": "いいえ、3D プリンティングを学校内で導入する予定はありません",
            "no_but_interesed": "いいえ、しかし学校では 3D プリンティングを現在探しています",
            "yes_they_do": "はい",
            "not_sure": "わかりません"
        }
    },
    "uses_printer_for": {
        "professional": "業務用",
        "education": "教育/研究",
        "hobby": "趣味",
        "dont_use": "3D プリンタを使用していない"
    },
    "level_values": {
        "administrator_principal_superintendent": "管理者／総括責任者／監督者",
        "biomedical_engineer": "生物医学",
        "c_level_executive": "経営幹部",
        "clinical_preclinical": "臨床／前臨床",
        "dean_department_head": "学科長／学科",
        "dentist": "歯科医",
        "designer": "設計者",
        "educator": "教育者",
        "engineer": "エンジニア",
        "equipment_manufacturer": "機器メーカー",
        "lab_owner": "LABオーナー",
        "lab_technician": "LAB技術者",
        "marketing": "マーケティング",
        "medical_education_and_training": "医療教育とトレーニング",
        "parent": "親",
        "practicing_physician": "開業医",
        "president_provost": "学長／学部長",
        "prosthetist_orthotist": "プロテーゼ医／整形外科医",
        "purchasing": "購買",
        "quality": "品質",
        "rd_engineering": "R&D／エンジニアリング",
        "sales": "販売",
        "senior_management_administration": "上級管理職／運営",
        "student": "学生",
        "training": "トレーニング",
        "other": "その他",
        "not_employed": "未就労"
    },
    "industry_values": {
        "aerospace": "航空宇宙",
        "architecture": "建築",
        "arts_entertainment": "芸術とエンターテイメント",
        "automotive": "自動車",
        "commercial_products": "商用製品",
        "consumer_electronics": "家電",
        "consumer_goods": "消費財",
        "dental": "歯科",
        "education": "教育",
        "engineering_consulting_service": "エンジニアリングコンサルティングサービス",
        "government_military": "政府／軍",
        "industrial_equipment": "産業機器",
        "jewelry": "宝飾品",
        "medical_device": "医療機器または設備",
        "service_bureau": "サービスビューロ",
        "toys": "玩具",
        "reseller": "再販業者",
        "other": "その他"
    },
    "company_size": {
        "0 - 100": "0 - 100",
        "100 - 500": "100 - 500",
        "500 - 1,000": "500 - 1,000",
        "1,000 - 2,500": "1,000 - 2,500",
        "2,500 - 5,000": "2,500 - 5,000",
        "5,000 - 10,000": "5,000 - 10,000",
        "10,000 - 15,000": "10,000 - 15,000",
        "15,000 - 20,000": "15,000 - 20,000",
        "20,000+": "20,000+",
        "not_company": "会社以外"
    },
    "yes_no_values": {
        "yes": "はい",
        "no": "いいえ"
    }
}
